import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './css/cabecalho.css';
import './css/slide.css';
import './css/Menu.css';
import './css-wesome/all.min.css';
import { getDatabase, ref, onValue } from 'firebase/database';
import firebaseApp, { camara, cidade } from './adm/admin/firebaseConfig';
import { 
  IconButton, useMediaQuery, Typography, Box, Button, 
  Dialog, DialogContent, DialogActions, Chip 
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EngineeringIcon from '@mui/icons-material/Engineering';
import CloseIcon from '@mui/icons-material/Close';
import LockIcon from '@mui/icons-material/Lock';
import { Facebook, Instagram, YouTube, WhatsApp } from '@mui/icons-material';
import Header from './utils/Header';

export default function Cabecalho({ config }) {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const location = useLocation();

  const [manutencao, setManutencao] = useState({
    ativo: false,
    bloquearAcesso: false,
    titulo: '',
    mensagem: '',
    corFundo: '#09090B',
    corTexto: '#FFFFFF',
    timeAtivo: false,
    tempoRetorno: '',
    chavesAcessoAdmin: ''
  });

  const [modalAberto, setModalAberto] = useState(false);
  const [timeLeft, setTimeLeft] = useState({ horas: 0, minutos: 0, segundos: 0 });

  const isDesktop = window.innerWidth > 768;
  const currentDate = new Date().toLocaleDateString('pt-BR', {
    weekday: 'long',
    day: 'numeric',
    month: isDesktop ? 'long' : 'numeric',
    year: 'numeric',
  });

  // Verifica se o admin está usando a chave de bypass na URL (ex: ?bypass=sua-chave)
  const searchParams = new URLSearchParams(location.search);
  const bypassKey = searchParams.get('bypass');
  const isAdminBypassed = manutencao.chavesAcessoAdmin && bypassKey === manutencao.chavesAcessoAdmin;

  const topBarBg = config?.isGradient
    ? `linear-gradient(135deg, ${config?.color1 || '#0C326F'} 0%, ${config?.color2 || '#1351B4'} 100%)`
    : (config?.color1 || config?.background || '#0C326F');

  const estiloIcones = {
    color: 'white',
    transition: 'color 0.3s ease',
    '&:hover': {
      color: '#1d1d1d',
    }
  };

  // Listener do Firebase em Tempo Real
  useEffect(() => {
    const databaseInstance = getDatabase(firebaseApp);
    const maintenanceRef = ref(databaseInstance, `manutencao`);

    const unsubscribe = onValue(maintenanceRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.val();
        setManutencao(data);
        
        if (data.ativo) {
          setModalAberto(true);
        }
      }
    });

    return () => unsubscribe();
  }, []);

  // Timer Regressivo em Tempo Real
  useEffect(() => {
    if (!manutencao.timeAtivo || !manutencao.tempoRetorno) return;

    const interval = setInterval(() => {
      const targetDate = new Date(manutencao.tempoRetorno).getTime();
      const now = new Date().getTime();
      const difference = targetDate - now;

      if (difference <= 0) {
        clearInterval(interval);
        setTimeLeft({ horas: 0, minutos: 0, segundos: 0 });
      } else {
        const horas = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutos = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const segundos = Math.floor((difference % (1000 * 60)) / 1000);
        setTimeLeft({ horas, minutos, segundos });
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [manutencao.timeAtivo, manutencao.tempoRetorno]);

  // SE A MANUTENÇÃO ESTIVER ATIVA, COM BLOQUEIO TOTAL E SEM BYPASS DO ADMIN:
  if (manutencao.ativo && manutencao.bloquearAcesso && !isAdminBypassed) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          bgcolor: manutencao.corFundo || '#09090B',
          color: manutencao.corTexto || '#FFFFFF',
          zIndex: 99999, // Fica acima de absolutamente tudo no site
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 3,
          textAlign: 'center',
          pointerEvents: 'all' // Garante interatividade apenas na tela de manutenção
        }}
      >
        <Box 
          sx={{ 
            width: 80, height: 80, borderRadius: '50%', 
            bgcolor: 'rgba(239, 68, 68, 0.15)', color: '#EF4444', 
            display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 
          }}
        >
          <LockIcon sx={{ fontSize: 45 }} />
        </Box>

        <Typography variant="h4" fontWeight="900" mb={2}>
          {manutencao.titulo || "Portal em Manutenção Programada"}
        </Typography>

        <Typography variant="body1" color="#A1A1AA" sx={{ maxWidth: '600px', lineHeight: 1.6, mb: 4 }}>
          {manutencao.mensagem}
        </Typography>

        {manutencao.timeAtivo && (
          <Box sx={{ p: 2.5, bgcolor: '#18181C', borderRadius: '16px', border: '1px solid #27272A', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
            <Typography variant="caption" color="#71717A" fontWeight="bold">PREVISÃO DE RETORNO</Typography>
            <Typography variant="h5" fontWeight="800" color="#F59E0B">
              {timeLeft.horas}h {timeLeft.minutos}m {timeLeft.segundos}s
            </Typography>
          </Box>
        )}
      </Box>
    );
  }

  return (
    <header>
      {/* 1. BARRA SUPERIOR FIXA DE DESTAQUE DE MANUTENÇÃO (CASO O BLOQUEIO TOTAL ESTEJA DESLIGADO) */}
      {manutencao.ativo && (
        <Box 
          sx={{ 
            bgcolor: manutencao.corFundo || '#F59E0B', 
            color: manutencao.corTexto || '#FFF',
            py: 1, 
            px: 2, 
            boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
          }}
        >
          <Box 
            display="flex" 
            justifyContent="space-between" 
            alignItems="center" 
            maxWidth="1200px" 
            margin="0 auto" 
            flexWrap="wrap"
            gap={1}
          >
            <Box display="flex" alignItems="center" gap={1.5}>
              <EngineeringIcon sx={{ fontSize: 26 }} />
              <Typography variant="body2" fontWeight="800">
                {manutencao.titulo || "MODO MANUTENÇÃO ATIVO"}
              </Typography>
            </Box>

            <Box display="flex" alignItems="center" gap={1.5}>
              {manutencao.timeAtivo && (
                <Chip
                  icon={<AccessTimeIcon style={{ color: '#FFF' }} />}
                  label={`Retorno: ${timeLeft.horas}h ${timeLeft.minutos}m ${timeLeft.segundos}s`}
                  size="small"
                  sx={{ bgcolor: 'rgba(0,0,0,0.25)', color: '#FFF', fontWeight: 'bold' }}
                />
              )}
              <Button 
                size="small" 
                variant="outlined" 
                onClick={() => setModalAberto(true)}
                sx={{ color: '#FFF', borderColor: 'rgba(255,255,255,0.6)', fontWeight: 'bold', textTransform: 'none' }}
              >
                Ver Detalhes
              </Button>
            </Box>
          </Box>
        </Box>
      )}

      {/* NAVBAR TRADICIONAL */}
      <Box
        component="nav"
        sx={{
          background: topBarBg,
          padding: '8px 0',
          boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: isMobile ? 'center' : 'space-between',
            alignItems: 'center',
            padding: '0 24px',
            flexWrap: isMobile ? 'wrap' : 'nowrap',
            textAlign: isMobile ? 'center' : 'left',
          }}
        >
          {!isMobile && (
            <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'white', whiteSpace: 'nowrap' }}>
              <i className="fa-solid fa-calendar-days"></i> {cidade}, {currentDate}
            </Typography>
          )}

          <Box sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: 'center', gap: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: isMobile ? 1 : 0 }}>
              <Link to={"/transparencia"} style={{ textDecoration: 'none' }}>
                <Button sx={{ fontWeight: 'bold', color: '#000', backgroundColor: 'white', '&:hover': { backgroundColor: '#1d1d1d', color: 'white' } }}>
                  Transparência Fiscal
                </Button>
              </Link>
              {!camara && (
                <Link to={"/app/notasfiscais"} style={{ textDecoration: 'none' }}>
                  <Button sx={{ fontWeight: 'bold', color: '#000', backgroundColor: 'white', '&:hover': { backgroundColor: '#1d1d1d', color: 'white' } }}>
                    NFS-E
                  </Button>
                </Link>
              )}
            </Box>

            {config?.design?.socialMedia && (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton component="a" href={config?.links?.facebook} target="_blank" sx={estiloIcones}><Facebook sx={{ fontSize: 28 }} /></IconButton>
                <IconButton component="a" href={config?.links?.instagram} target="_blank" sx={estiloIcones}><Instagram sx={{ fontSize: 28 }} /></IconButton>
                <IconButton component="a" href={config?.links?.youtube} target="_blank" sx={estiloIcones}><YouTube sx={{ fontSize: 28 }} /></IconButton>
                <IconButton component="a" href={config?.links?.whatsapp} target="_blank" sx={estiloIcones}><WhatsApp sx={{ fontSize: 28 }} /></IconButton>
              </Box>
            )}
          </Box>
        </Box>
      </Box>

      <Box className="slide">
        <Link to={config?.bannerLink || "#"} style={{ textDecoration: 'none' }}>
          <Box
            component="img"
            src={config?.banner || "https://publish.nstu.ru/bitrix/templates/aspro-scorp/images/background.png"}
            alt="Banner"
            className="imagem"
          />
        </Link>
      </Box>

      <Header config={config} />

      {/* POP-UP MODAL (CASO O BLOQUEIO TOTAL ESTEJA DESLIGADO, MAS A MANUTENÇÃO ESTEJA ATIVA) */}
      <Dialog
        open={modalAberto}
        onClose={() => setModalAberto(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { bgcolor: '#121214', color: '#FFF', borderRadius: '24px', border: '1px solid #27272A', p: 1 } }}
        BackdropProps={{ sx: { backdropFilter: 'blur(8px)', bgcolor: 'rgba(0,0,0,0.85)' } }}
      >
        <Box display="flex" justifyContent="flex-end">
          <IconButton onClick={() => setModalAberto(false)} sx={{ color: '#A1A1AA' }}><CloseIcon /></IconButton>
        </Box>

        <DialogContent sx={{ textAlign: 'center', pb: 3 }}>
          <Box sx={{ width: 70, height: 70, borderRadius: '50%', bgcolor: 'rgba(245, 158, 11, 0.15)', color: '#F59E0B', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', mb: 2 }}>
            <EngineeringIcon sx={{ fontSize: 40 }} />
          </Box>
          <Typography variant="h5" fontWeight="900" color="#FFF" mb={1}>{manutencao.titulo}</Typography>
          <Typography variant="body1" color="#A1A1AA" sx={{ lineHeight: 1.6, mb: 3 }}>{manutencao.mensagem}</Typography>

          {manutencao.timeAtivo && (
            <Box sx={{ p: 2, bgcolor: '#18181C', borderRadius: '16px', border: '1px solid #27272A', display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
              <Typography variant="caption" color="#71717A" fontWeight="bold">PREVISÃO DE RETORNO</Typography>
              <Typography variant="h6" fontWeight="800" color="#F59E0B">
                {timeLeft.horas}h {timeLeft.minutos}m {timeLeft.segundos}s
              </Typography>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
          <Button variant="contained" onClick={() => setModalAberto(false)} sx={{ bgcolor: '#0F71FD', fontWeight: 'bold', borderRadius: '12px', px: 4, py: 1.2 }}>
            Entendido, Continuar Navegando
          </Button>
        </DialogActions>
      </Dialog>
    </header>
  );
}